export const SAVE_ALL_NOTE_TYPES = 'SAVE_ALL_NOTE_TYPES'
